import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var AlertTwoTone = function AlertTwoTone(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.237 2.6689c0.54329-0.9567 1.4258-0.95378 1.9674 0l10.053 17.703c0.54329 0.9567 0.085132 1.7323-1.0247 1.7323h-20.025c-1.1092 0-1.5663-0.77848-1.0247-1.7323l10.053-17.703z",
    fill: "#F8E71C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.32 8.8864c0-0.49363 0.40017-0.8938 0.90156-0.8938 0.49792 0 0.90156 0.41098 0.90156 0.8938v6.2764c0 0.49363-0.40017 0.8938-0.90156 0.8938-0.49792 0-0.90156-0.41098-0.90156-0.8938v-6.2764zm-0.20035 9.287c0-0.61237 0.4891-1.1088 1.1019-1.1088 0.60857 0 1.1019 0.49216 1.1019 1.1088 0 0.61237-0.4891 1.1088-1.1019 1.1088-0.60857 0-1.1019-0.49216-1.1019-1.1088z",
    fill: "#404040"
  })));
};

AlertTwoTone.displayName = 'AlertTwoTone';
export default AlertTwoTone;